import TextCell from 'components/TextCell';
import type { ManagedFleet } from '../..';

interface PlatformAccountSourceIdCellProps {
  rowData: ManagedFleet;
}

export default function PlatformAccountSourceIdCell({
  rowData: { sourceId },
}: PlatformAccountSourceIdCellProps) {
  return <TextCell text={sourceId} />;
}
